// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"BadgeWrapper_badgeWrapper__8CaAj"};